import {
  BatchUpdateCartBody,
  CartTotalBody,
  CartTotalResponse,
  QueryStringSearch,
  UpdateCart,
} from '@diamond/shared/types';
import { apiInstance, buyerCaptureException } from '@diamond/shared/utils';
import { AxiosError } from 'axios';
import cleanDeep from 'clean-deep';

export const getCart = async (
  token: string,
  params: Readonly<QueryStringSearch>
) => {
  const url = '/cart';
  const { data } = await apiInstance(token).get(url, {
    params: cleanDeep(params),
  });
  return data;
};

export const getCartData = async (
  token: string,
  warehouseId?: string,
  searchQuery?: string
) => {
  const params = {
    search_query: searchQuery?.trim() ?? null,
    warehouse: warehouseId ?? null,
    sort_by_code: 'product_name_asc',
    size: 9999,
    page: 1,
  };

  const url = '/cart';
  const { data } = await apiInstance(token).get(url, {
    params: cleanDeep(params),
  });
  return data.data || [];
};

export const patchCart = async (
  token: string,
  id: string,
  params: UpdateCart
) => {
  const url = `/cart/${id}`;
  const { data } = await apiInstance(token).patch(url, {
    id,
    note: params.note,
    quantity: params.quantity,
  });
  return data;
};
export const patchBatchCart = async (
  token: string,
  id: string,
  body: BatchUpdateCartBody
) => {
  const url = `/cart/batch`;
  const { data } = await apiInstance(token).patch(url, body);
  return data;
};

export async function postCartTotal(
  token: string,
  payload: CartTotalBody
): Promise<CartTotalResponse> {
  const url = `/cart/total`;
  const { data } = await apiInstance(token).post<CartTotalResponse>(
    url,
    payload
  );
  return data;
}

export const deleteCart = async (token: string, id: string) => {
  try {
    const url = `/cart/${id}`;
    const { data } = await apiInstance(token).delete(url);
    return data;
  } catch (error: unknown) {
    if (error instanceof AxiosError) {
      const errorData = error.response?.data;
      buyerCaptureException(errorData, (scope) => {
        scope.setTags({
          queryKey: 'deleteCart error',
          status_code: errorData?.statusCode,
        });
        scope.setContext('error', {
          error: errorData,
        });
        scope.setExtra('cart_id', id);
        scope.setLevel('error');
      });
      throw new Error(errorData?.message || 'Failed to delete cart item');
    }
    throw error;
  }
};

export const deleteAllCart = async (token: string) => {
  try {
    const url = `/cart/all`;
    const { data } = await apiInstance(token).delete(url);
    return data;
  } catch (error: unknown) {
    if (error instanceof AxiosError) {
      const errorData = error.response?.data;
      buyerCaptureException(errorData, (scope) => {
        scope.setTags({
          queryKey: 'deleteAllCart error',
          status_code: errorData?.statusCode,
        });
        scope.setContext('error', {
          error: errorData,
        });
        scope.setLevel('error');
      });
      throw new Error(errorData?.message || 'Failed to delete all cart items');
    }
    throw error;
  }
};
